import React from 'react';
import { PrismicHTMLParser } from '../../PrismicHTMLParser';
import { Arrow } from '../../Icons';
import { Item } from './types';

const Style = ({
    style,
    setSelectedStyle,
    isSelectedStyle,
}: {
    style: Item;
    setSelectedStyle: any;
    isSelectedStyle: boolean;
}) => (
    <div
        className={`MasteringDemos-style ${isSelectedStyle ? 'Active' : ''}`}
        onClick={setSelectedStyle}
    >
        <PrismicHTMLParser className="MasteringDemos-style-name u-text-xl">
            {style.mastering_demos_style.html}
        </PrismicHTMLParser>
        <span className="MasteringDemos-style-arrow">
            <Arrow size="small" />
        </span>
        <div className="Wrapper-track-name">
            <PrismicHTMLParser className="MasteringDemos-style-title u-text-xl">
                {style.mastering_demos_track_title.html}
            </PrismicHTMLParser>
        </div>
    </div>
);

export { Style };
